import { createRouter, createWebHistory } from 'vue-router'
import ClaimInfo from '../views/ClaimInfo.vue'

const routes = [
  {
    path: '/:hashkey',
    component: ClaimInfo
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
